var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-user-component",attrs:{"id":"header_user_component"}},[_c('div',{staticClass:"header-profile-inner"},[_c('router-link',{attrs:{"to":{ path: '/profile' }}},[_c('div',{staticClass:"header-profile-fullname"},[_vm._v("\n                "+_vm._s(_vm.fullname)+"\n            ")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e397cdce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/partials/header/middlebar/HeaderUser.vue
// module id = 3eU3
// module chunks = 0